<template>
    <v-container fluid>
        <v-card class="ma-2" outlined>
            <v-card-title>
                <v-btn icon @click="goBack">
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                Redemption History
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                <!-- <v-btn color="primary" @click="refreshData">
                    <v-icon>mdi-refresh</v-icon>
                    Refresh
                </v-btn> -->
                <!-- <v-btn color="success" class="ml-2" @click="openRedeemDialog">
                    <v-icon>mdi-plus</v-icon>
                    Redeem Reward
                </v-btn> -->
            </v-card-title>



            <!-- Redemption History Table -->
            <v-data-table
                :headers="headers"
                :items="redemptions"
                :search="search"
                :sort-by="['redeemedDate']"
                :sort-desc="['desc']"
                :loading="loading"
                class="elevation-1"
                :items-per-page="20"
                :footer-props="{
                    'items-per-page-options': [10, 20, 50, 100]
                }"
            >
                <template #[`item.image`]="{ item }">
                    <v-img
                        :src="item.image"
                        max-width="100"
                        max-height="100"
                        contain
                    ></v-img>
                </template>
                <template #[`item.createdDate`]="{ item }">
                    {{ formatDate(item.createdDate) }}
                </template>
                <template #[`item.status`]="{ item }">
                    <v-select
                        v-model="item.status"
                        :items="['pending', 'paid','sent']"
                        dense
                        outlined
                        hide-details
                        @change="updateStatus(item)"
                        :color="getStatusColor(item.status)"
                        v-if="item.status === 'pending' || item.status === 'paid'"
                    >
                        <template v-slot:selection="{ item }">
                            <v-chip
                                :color="getStatusColor(item)"
                                text-color="white"
                            >
                                {{ item }}
                            </v-chip>
                        </template>
                    </v-select>
                    <span v-else>
                        <v-chip
                            :color="getStatusColor(item.status)"
                            text-color="white"
                        >
                            {{ item.status }}
                        </v-chip>
                    </span>
                </template>
                <template #[`item.actions`]="{ item }">
                    <v-icon class="mr-2" @click="viewDetails(item)">
                        mdi-eye
                    </v-icon>
                    <v-icon @click="removeRedemption(item)" v-if="item.status === 'pending'">
                        mdi-delete
                    </v-icon>
                </template>
            </v-data-table>

            <!-- Details Dialog -->
            <v-dialog v-model="detailsDialog" max-width="600px">
                <v-card>
                    <v-card-title>
                        <span class="text-h5">Redemption Details</span>
                    </v-card-title>

                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="6">
                                <strong>Reward:</strong> {{ selectedRedemption.rewardName }}
                            </v-col>
                            <v-col cols="12" md="6">
                                <strong>Redeem By:</strong> {{ selectedRedemption.redeemBy }}
                            </v-col>
                            <v-col cols="12">
                                <strong>Name:</strong> {{ selectedRedemption.name }}
                            </v-col>
                            <v-col cols="12" md="6">
                                <strong>Phone Number:</strong> {{ selectedRedemption.phoneNumber }}
                            </v-col>
                            <v-col cols="12" md="6">
                                <strong>Address:</strong> {{ selectedRedemption.address }}
                            </v-col>
                            <v-col cols="12" md="6">
                                <strong>Redeem Date:</strong> {{ selectedRedemption.redeemedDate }}
                            </v-col>
                            <v-col cols="12" md="6">
                                <strong class="mr-2">Status:</strong> 
                                <v-chip
                                    :color="getStatusColor(selectedRedemption.status)"
                                    text-color="white"
                                >
                                    {{ selectedRedemption.status }}
                                </v-chip>
                            </v-col>
                            <v-col cols="12" md="6" v-if="selectedRedemption.couponCode">
                                <strong>Coupon:</strong> {{ selectedRedemption.couponCode }}
                            </v-col>
                            <v-col cols="12" md="6" v-if="selectedRedemption.paidDate">
                                <strong>Payment Date:</strong> {{ selectedRedemption.paidDate }}
                            </v-col>
                            <v-col cols="12" md="6" v-if="selectedRedemption.paymentReferenceId">
                                <strong>Payment Id:</strong> {{ selectedRedemption.paymentReferenceId }}
                            </v-col>
                            <v-col cols="12" md="6" v-if="selectedRedemption.courierName">
                                <strong>Courier:</strong> {{ selectedRedemption.courierName }}
                            </v-col>
                            <v-col cols="12" md="6" v-if="selectedRedemption.trackingNumber">
                                <strong>Tracking Number:</strong> {{ selectedRedemption.trackingNumber }}
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="detailsDialog = false">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- Delete Redemption Confirmation Dialog -->
            <v-dialog v-model="deleteRedemptionDialog" max-width="400px">
                <v-card>
                    <v-card-title class="text-h5">
                        Are you sure you want to delete the redemption?
                    </v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="grey darken-1" text @click="deleteRedemptionDialog = false">
                            Cancel
                        </v-btn>
                        <v-btn text @click="confirmDeleteRedemption">
                            Delete
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- Redeem Reward Dialog -->
            <v-dialog v-model="redeemDialog" max-width="500px">
                <v-card>
                    <v-card-title>Redeem Reward</v-card-title>
                    <v-card-text>
                        <v-form v-model="redeemFormValid">
                            <v-select
                                v-model="redeemForm.rewardId"
                                :items="rewards"
                                item-text="name"
                                item-value="id"
                                label="Reward"
                                :rules="[redeemFormRules.required]"
                                required
                            ></v-select>
                            <v-text-field
                                v-model="redeemForm.name"
                                label="Name"
                                :rules="[redeemFormRules.required]"
                                required
                            ></v-text-field>
                            <v-text-field
                                v-model="redeemForm.phoneNumber"
                                label="Phone Number"
                                :rules="[redeemFormRules.required, redeemFormRules.phone]"
                                required
                            ></v-text-field>
                            <v-text-field
                                v-model="redeemForm.address"
                                label="Address"
                            ></v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="redeemDialog = false">Cancel</v-btn>
                        <v-btn color="success" text :disabled="!redeemForm.rewardId || !redeemForm.name || !redeemForm.phoneNumber" @click="submitRedeem">Redeem</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- Tracking Information Dialog -->
            <v-dialog v-model="trackingDialog" max-width="500px">
                <v-card>
                    <v-card-title>Add Tracking Information</v-card-title>
                    <v-card-text>
                        <v-form v-model="trackingFormValid">
                            <v-select
                                v-model="trackingForm.courierName"
                                :items="courierOptions"
                                label="Courier"
                                :rules="[trackingFormRules.required]"
                                required
                            ></v-select>
                            <v-text-field
                                v-model="trackingForm.trackingNumber"
                                label="Tracking Number"
                                :rules="[trackingFormRules.required]"
                                required
                            ></v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="cancelTracking">Cancel</v-btn>
                        <v-btn color="success" text :disabled="!trackingForm.courierName || !trackingForm.trackingNumber" @click="submitTracking">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
    </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import getRewardRedemptions from "../data/getRewardRedemptions";
import updateRedemptionStatus from "../data/updateRedemptionStatus";
import formatData from "../utils/formatData";
import addRewardRedemption from "../data/addRewardRedemption";
import getWellnessRewards from "../data/getWellnessRewards";
import removeRewardsHistory from "../data/removeRewardsHistory";
import getUserInfoByUserId from "../data/getUserInfoByUserId";

export default {
    name: 'WellnessRewardHistory',
    metaInfo: {
        title: 'Rewards History'
    },
    data() {
        return {
            loading: false,
            search: "",
            detailsDialog: false,
            deleteRedemptionDialog: false,
            redeemDialog: false,
            trackingDialog: false,
            headers: [
                { value: 'image', sortable: false },
                { text: 'Redeem Date', value: 'redeemedDate' },
                { text: 'Reward', value: 'rewardName' },
                { text: 'Points', value: 'redeemedPoints' },
                { text: 'Name', value: 'name' },
                { text: 'Phone Number', value: 'phoneNumber' },
                { text: 'Address', value: 'address' },
                { text: 'Status', value: 'status', width: '100px' },
                { text: 'Actions', value: 'actions', sortable: false }
            ],
            redemptions: [],
            rewards: [],
            selectedRedemption: {},
            selectedRewardId: null,
            redemptionToDelete: {},
            // Redeem form
            redeemForm: {
                rewardId: '',
                rewardName: '',
                name: '',
                phoneNumber: '',
                address: '',
                status: 'pending'
            },
            redeemFormValid: false,
            redeemFormRules: {
                required: v => !!v || 'Required',
                phone: v => !v || /^\d{9,15}$/.test(v) || 'Invalid phone number'
            },
            // Tracking form
            trackingForm: {
                courierName: '',
                trackingNumber: ''
            },
            trackingFormValid: false,
            trackingFormRules: {
                required: v => !!v || 'Required'
            },
            courierOptions: [
                'ไปรษณีย์ไทย',
                'Kerry Express',
                'Flash Express',
                'J&T Express',
                'SCG Express',
                'DHL',
                'Ninja Van',
                'Best Express'
            ],
            itemToUpdate: null
        };
    },

    computed: {
        ...mapGetters([
            "loggedInUserId",
            "isAuthenticated",
            "isSuperAdmin",
            "isChallengeAdmin"
        ])
    },

    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | Rewards History";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });
    },

    methods: {
        async initialize() {
            if (this.isSuperAdmin) {
                (async () => {
                    this.loading = true;
                    // Load rewards for the redeem form
                    this.rewards = await getWellnessRewards();
                    // Load redemptions for specific reward or all redemptions
                    this.redemptions = await getRewardRedemptions();
                    this.loading = false;
                })();
            } else {
                this.$router.push('/dashboard');
            }
        },

        viewDetails(item) {
            (async () => {  
                this.selectedRedemption = { ...item };
                const redeemBy = await getUserInfoByUserId(this.selectedRedemption.uid);
                this.selectedRedemption.redeemBy = redeemBy.name;
                this.selectedRewardId = item.rewardId;
                this.detailsDialog = true;
            })();
        },

        getStatusColor(status) {
            const colors = {
                'pending': 'orange',
                'paid': 'blue',
                'sent': 'green'
            };
            return colors[status] || 'grey';
        },

        async updateStatus(item) {
            if (item.status === 'sent') {
                this.itemToUpdate = item;
                this.trackingForm = {
                    courierName: '',
                    trackingNumber: ''
                };
                this.trackingDialog = true;
            }
        },

        formatDate(date) {
            return formatData('date', date);
        },

        goBack() {
            this.$router.go(-1);
        },

        refreshData() {
            this.initialize();
        },

        removeRedemption(item) {
            this.redemptionToDelete = item;
            this.deleteRedemptionDialog = true;
        },

        async confirmDeleteRedemption() {
            try {
                // Remove the redemption from the list
                const index = this.redemptions.indexOf(this.redemptionToDelete);
                if (index > -1) {
                    this.redemptions.splice(index, 1);
                }
                await removeRewardsHistory(this.redemptionToDelete.rewardId, this.redemptionToDelete.id);
                this.deleteRedemptionDialog = false;
                this.redemptionToDelete = {};
            } catch (error) {
                console.error('Error deleting redemption:', error);
            }
        },

        openRedeemDialog() {
            this.redeemForm = {
                rewardId: '',
                rewardName: '',
                name: '',
                phoneNumber: '',
                address: '',
                status: 'pending'
            };
            this.redeemDialog = true;
        },

        async submitRedeem() {
            if (!this.redeemForm.rewardId || !this.redeemForm.name || !this.redeemForm.phoneNumber) return;
            try {
                const selectedReward = this.rewards.find(r => r.id === this.redeemForm.rewardId);

                let assignedCode = '';
                if (selectedReward && selectedReward.isCoupon) {
                    const existingRedemptions = this.redemptions.filter(r => r.rewardId === selectedReward.id && r.couponCode);
                    const usedCodes = existingRedemptions.map(r => r.couponCode);
                    const availableCodes = (selectedReward.couponCodes || []).filter(code => !usedCodes.includes(code));
                    
                    if (availableCodes.length === 0) {
                        alert('No available coupon codes for this reward.');
                        return;
                    }
                    assignedCode = availableCodes[0];
                }

                this.redeemForm.rewardName = selectedReward ? selectedReward.name : '';
                this.redeemForm.rewardImage = selectedReward ? selectedReward.image : '';
                this.redeemForm.rewardId = selectedReward ? selectedReward.id : '';
                
                let payload = {
                    rewardName: this.redeemForm.rewardName,
                    rewardImage: this.redeemForm.rewardImage,
                    rewardId: this.redeemForm.rewardId,
                    name: this.redeemForm.name,
                    phoneNumber: this.redeemForm.phoneNumber,
                    redeemedPoints: selectedReward.redeemedPoints,
                    address: this.redeemForm.address,
                    uid: this.loggedInUserId,
                    status: 'pending',
                    createdDate: new Date(),
                    createdBy: this.loggedInUserId,
                    updatedDate: new Date(),
                    updatedBy: this.loggedInUserId,
                    redeemedDate: new Date()
                };

                if (selectedReward && selectedReward.isCoupon) {
                    payload.couponCode = assignedCode;
                }

                await addRewardRedemption(this.redeemForm.rewardId, payload);
                this.redeemDialog = false;
                this.refreshData();
            } catch (error) {
                console.error('Error redeeming reward:', error);
            }
        },

        cancelTracking() {
            // Reset the status back to pending if user cancels
            if (this.itemToUpdate) {
                this.itemToUpdate.status = 'pending';
            }
            this.trackingDialog = false;
            this.itemToUpdate = null;
        },

        async submitTracking() {
            if (!this.trackingForm.courierName || !this.trackingForm.trackingNumber) return;
            
            try {
                // Update the item with tracking information
                if (this.itemToUpdate) {
                    this.itemToUpdate.courierName = this.trackingForm.courierName;
                    this.itemToUpdate.trackingNumber = this.trackingForm.trackingNumber;
                    
                    // Update the status with tracking information
                    await updateRedemptionStatus(
                        this.itemToUpdate.rewardId, 
                        this.itemToUpdate.id, 
                        this.itemToUpdate.status, 
                        this.loggedInUserId,
                        this.trackingForm.courierName,
                        this.trackingForm.trackingNumber
                    );
                }
                
                this.trackingDialog = false;
                this.itemToUpdate = null;
            } catch (error) {
                console.error('Error updating tracking information:', error);
            }
        }
    }
};
</script> 